













































































































































































































































































































































































































// Vue
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { mapGetters, mapActions, mapMutations } from "vuex";
import { Mixins } from "vue-mixin-decorator";

// Components
import Icon, { IconEnum } from "@/shared/components/icon.component.vue";
import SaleInfoViewSpecialOption from "@/clickbuy/purchase/views/sale-info-special-options.view.vue";
import SearchAutocomplete from "@/shared/components/SearchAutocomplete.component.vue";
import Btn, {
  BtnPredefinedStyle,
  BtnColor,
  BtnWidth
} from "@/shared/components/btn.component.vue";
import CheckIcon, {
  CheckIconColor
} from "@/shared/components/CheckIcon.component.vue";
import ExpansionPanel from "@/shared/components/expansion.panel.component.vue";
import Field from "@/shared/components/field.component.vue";
import SpotlightText, {
  SpotlightTextColor,
} from '@/shared/components/SpotlightText.component.vue';

// Constants
import Assets from "@/constants/assets";
import Constans from "@/constants/constants";

// Enums
import { LineColor } from "@/clickbuy/purchase/views/shopping-cart/shopping-cart-line/index.vue";

// Services
import {
  ConvocationService,
  TypeOfProduct
} from "@/manager/convocation/convocation.service";
import { PurchaseService } from "@/manager/purchase/purchase.service";
import BillingService from '@/manager/billing/billing.service';

// Mixins
import SearchMixin from "@/shared/mixins/search.mixin";
import ErrorMixin from '@/shared/mixins/error.mixin';
import NotificationMessage from '@/shared/mixins/notificationMessage.mixin.ts';

// Models
import { Client } from "@/manager/client/client.model";
import {
  Purchase,
  PurchasePaymentStatus
} from "@/clickbuy/purchase/models/purchase.model";
import { PurchaseLine } from "@/clickbuy/purchase/models/purchase-line.model";
import Modal, {
  ModalTitleColor
} from "@/shared/components/Modal.component.vue";

// Views
import ShoppingCart from "@/clickbuy/purchase/views/shopping-cart/index.vue";

// Filters
import pluralizeFilter from "@/shared/filters/pluralize.filter";
import round from "@/shared/filters/round.filter";
import Input from "@/style-guide/partials/input/input.vue";
import Dropdown, {
  DropdownWidth,
  DropdownStyle
} from "@/shared/components/Dropdown.component.vue";
import { SwitchActiveColor } from "@/shared/components/button-switch.component.vue";
import { product } from "@/manager/product/store";
import ItemThumb, {
  ItemThumbPrefeginedStyle
} from "@/shared/components/item-thumb.component.vue";
import { TimetablesInterface } from "@/shared/interfaces/timetables.interface";
import { BudgetCommunicationStatus, BudgetCommunicationStatusListeral } from "@/manager/budget/models/budget.model";
import { MenuElementBgColor } from "@/shared/components/menu-element.component.vue";
import Tooltip, {
  TooltipColor,
  TooltipAlign,
} from "@/shared/components/Tooltip.component.vue";

interface MixinInterface extends NotificationMessage, ErrorMixin {
}

@Component({
  components: {
    Input,
    Dropdown,
    SaleInfoViewSpecialOption,
    Icon,
    Btn,
    SearchAutocomplete,
    ShoppingCart,
    Modal,
    CheckIcon,
    ExpansionPanel,
    ItemThumb,
    Tooltip,
    Field,
    SpotlightText
  },
  computed: {
    ...mapGetters({
      getClient: "getClient",
      getProduct: "getProduct",
      getConvocation: 'getConvocation',
      clientList: "getClientList",
      getSelectedClient: "getSelectedClient",
      selectedBusiness: "getInternalBussinessSelected",
      currentPurchase: "getCurrentPurchase",
      hasClientSelected: "currentPurchaseHasClient",
      formComplete: "currentPurchaseIsComplete",
      purchaseFinished: "currentPurchaseFinished",
      totalAmountGift: "currentPurchaseGiftTotalAmount",
      sellingCourse: "currentPurchaseTypeOfProductIsCourse",
      sellingBook: "currentPurchaseTypeOfProductIsBook",
      sellingMerchandising: "currentPurchaseTypeOfProductIsMerchandising",
      previousPurchases: "getPurchaseList",
      hasPreviousPurchases: "hasPurchases",
      currentPurchaseTypeOfProduct: "getCurrentPurchaseTypeOfProduct",
      previousPurchaseIsCanceled: "previousPurchaseIsCanceled",
      convocationBalance: "getConvocationBalance",
      hasPreviousPurchaseNotCanceled: "hasPreviousPurchaseNotCanceled",
      userMoneyFlow: "getUserMoneyFlow",
      hasUserMoneyFlow: "hasUserMoneyFlow"
    })
  },
  methods: {
    ...mapMutations({
      selectBusiness: "setInternalBussinessSelected"
    })
  },
  filters: {
    pluralizeFilter,
    round
  }
})
export default class SaleInfoView extends Mixins<MixinInterface>(SearchMixin, NotificationMessage, ErrorMixin) {
  private assets = Assets;
  private iconEnum = IconEnum;
  private dropdownWidth = DropdownWidth;
  private DropdownStyle = DropdownStyle;
  private btnColor = BtnColor;
  private btnWidth = BtnWidth;
  private btnPredefinedStyle = BtnPredefinedStyle;
  private modalTitleColor = ModalTitleColor;
  private getProduct!: any;
  private getClient!: any;
  private clientList!: any;
  private internalBusinessList: Array<any> = [];
  private previousPurchases!: any;
  private selectedClient!: any;
  private selectedPhoneClient!: any;
  private hasPreviousPurchases!: any;
  private hasClientSelected!: any;
  private currentPurchase!: any;
  private formComplete!: any;
  private purchaseFinished!: any;
  private getSelectedClient!: any;
  private getSelectedCompany!: any;
  private totalAmountGift!: any;
  private currentPurchaseTypeOfProduct!: any;
  private sellingCourse!: boolean;
  private sellingBook!: boolean;
  private sellingMerchandising!: boolean;
  private previousPurchaseIsCanceled!: boolean;
  private hasPreviousPurchaseNotCanceled!: boolean;
  private convocationBalance!: number;
  private userMoneyFlow!: number;
  private hasUserMoneyFlow!: boolean;
  private modalCancelPurchaseOpened = false;
  private convocationId = "";
  private recommendationBonus = true;
  private recommendationBonusClientSelected: any = {};
  private telephoneSale = false;
  private webSale = false;
  private checkIconColor = CheckIconColor;
  private selectedBusiness!: any;
  private getConvocation!: any;
  private tooltipColor = TooltipColor;
  private searchPhoneString = '+34'
  private searchString: any;
  private searchNifString: any;

  // private refundedOriginBillExist = false;
  // private BillhasRefundedBill = false;

  private billCommunicationStatusText(billCommunicationStatus: any) {
    switch (billCommunicationStatus) {
      case 0:
        return 'Fac. sin enviar'
      case 1:
        return 'Fac. enviada'
      case 2:
        return 'Fac. reenviada'
      case 3:
        return 'Fac. pendiente'
    }
  }

  get isOldTLP() {
    return this.client.oldTopLevelPack;
  }

  get tooltipTextTLP() {
    let text = 'Top Level Pack';
    if (this.isOldTLP) {
      text = 'TLP Antiguo';
    }
    return text;
  }

  get tooltipTextPWP() {
    let text = 'Power Pack';
    return text;
  }

  get tooltipTextCN3() {
    let text = 'Certificado de nivel 3';
    return text;
  }

  get topLevelPackIconColor() {
    let color = this.checkIconColor.Gold;
    if (this.isOldTLP) {
      color = this.checkIconColor.GoldDark;
    }
    if (this.selectedClient.tlp) {
      color = this.selectedClient.tlp.color;
    }
    return color;
  }

  get topLevelPackTooltipColor() {
    let color = this.tooltipColor.Secondary;
    return color;
  }

  get powerPackIconColor() {
    let color = this.checkIconColor.Gold;
    if (this.selectedClient.pwp) {
      color = this.selectedClient.pwp.color;
    }
    return color;
  }

  get powerPackTooltipColor() {
    let color = this.tooltipColor.Secondary;
    return color;
  }

  private generateUrlChangeData() {
    // var changeDataUrl = (window.location.href + '/' + this.currentPurchase.bill.id).replace('/app/', '/public/');
    var changeDataUrl = window.location.href.split("#")[0] + "#/public/billing/" + this.currentPurchase.bill.id

    const navigatorAny:any = navigator
    navigatorAny.clipboard.writeText(changeDataUrl)
      .then(() => {
        // this.emitMessageError({ 'data': { 'detail': "Enlace copiado al portapapeles" } });
        this.showNotification(
          "Enlace copiado",
          SpotlightTextColor.Primary,
        );
      })
      .catch((err: any) => {
        console.error('Error al copiar el enlace:', err);
      });
  }

  private sendChangeDataBillEmail() {
    BillingService.sendChangeDataBillEmail(this.currentPurchase.bill.id).then(() => {
      this.showNotification(
        "Email enviado",
        SpotlightTextColor.Primary,
      );
    });
  }

  @Watch("getSelectedClient")
  public watchGetSelectedClient(newVal: any, oldVal: any) {
    if (newVal) {
      this.selectClient(newVal);
    }
  }

  private created() {
    this.setUserMoneyFlow(0);
    this.convocationId = this.$route.params.convocationId;
    this.fetchConvocation();
    this.fetchInternalBusinessList();
  }

  get reserveAmountValue() {
    let reserve = this.currentPurchase.reserveAmount || 0;
    if (reserve === 0) {
      reserve = undefined;
    }
    return round(reserve, 2);
  }

  private mounted() { }

  private get specialAnnouncement() {
    return this.$route.query.specialAnnouncement;
  }

  get hasBusinessSelected() {
    return this.selectedBusiness.id !== -1;
  }

  get subtitleClass() {
    return this.specialAnnouncement ? "color-white" : "color-secondary";
  }

  get searchAutocompletePlaceholder() {
    return this.specialAnnouncement ? "Buscar" : "Busca un cliente";
  }

  get convocation() {
    return this.getConvocation(this.convocationId);
  }

  get productCategoryTranslation() {
    let translation = "Sin categoría seleccionada";
    if (!this.specialAnnouncement && this.sellingCourse) {
      translation = "Cursos";
    } else if (this.sellingBook) {
      translation = "Libros";
    } else if (this.sellingMerchandising) {
      translation = "Merchandising";
    } else if (this.specialAnnouncement) {
      translation = "Ventas oficina";
    }
    return translation;
  }

  get formatConvocationDates(): string {
    return ConvocationService.formatDates(this.convocation
      .timetables as TimetablesInterface[]);
  }

  test() {
    this.recommendationBonus = !this.recommendationBonus;
  }

  get purchaseIsFinished() {
    if (this.purchaseFinished) {
      return true
    } else {
      return false
    }
    // return (
    //   this.purchaseFinished &&
    //   (!this.hasPreviousPurchases ||
    //     (this.hasPreviousPurchases && this.currentPurchase.addNewPurchase))
    // );
  }

  private budgetIsDispatched(budget: any) {
    if (budget) {
      return budget.communicationStatus == BudgetCommunicationStatus.Dispatched
    } else {
      return ''
    }
  }

  private budgetIsAdjust(budget: any) {
    if (budget) {
      return budget.communicationStatus == BudgetCommunicationStatus.Adjust;
    } else {
      return ''
    }
  }

  private budgetIsAccepted(budget: any) {
    if (budget) {
      return budget.communicationStatus == BudgetCommunicationStatus.Accepted
    } else {
      return ''
    }
  }

  private budgetIsRejected(budget: any) {
    if (budget) {
      budget.communicationStatus == BudgetCommunicationStatus.Rejected
    } else {
      return ''
    }
  }

  private budgetStateTooltip(budget: any) {
    if (budget) {
      const tooltip = {
        color: TooltipColor.BlueDark,
        text: BudgetCommunicationStatusListeral[budget.communicationStatus],
      };
      if (this.budgetIsAccepted(budget)) {
        tooltip.color = TooltipColor.Primary;
      } else if (this.budgetIsRejected(budget)) {
        tooltip.color = TooltipColor.Red;
      } else if (this.budgetIsDispatched(budget)) {
        tooltip.color = TooltipColor.Secondary;
      }
      return tooltip;
    } else {
      return null;
    }
  }

  private modifyPurchase(index: any) {
    this.clearPurchase();
    this.selectClient(this.selectedClient, true, index);
    // this.previousPurchases[0].modifyPurchase = true;
    // this.setCurrentPurchaseLoading(true);
    // this.$store.dispatch("setCurrentPurchase", this.previousPurchases[0]);

    // this.setCurrentPurchaseLoading(false);
  }

  get subtitle() {
    let text = "Utiliza el buscador para buscar a un cliente:";
    if (
      this.hasClientSelected &&
      !this.formComplete &&
      this.previousPurchases.length === 0
    ) {
      text = "Selecciona los productos que el cliente quiera comprar:";
    } else if (this.hasClientSelected && this.previousPurchases.length > 0) {
      text = "Este cliente ya ha realizado una compra durante este curso:";
    } else if (this.hasClientSelected && this.formComplete) {
      text = "Realiza el cobro de la reserva y finaliza la compra:";
    } else if (this.specialAnnouncement) {
      text = "Busca un cliente o crea uno nuevo:";
    }
    return text;
  }

  get client() {
    return this.getClient(this.selectedClient.id);
  }

  get sellingTaxProducts() {
    return this.sellingBook || this.sellingMerchandising;
  }

  get clientSelectedName() {
    let name = "SIN CLIENTE ASOCIADO:";
    if (this.hasClientSelected) {
      name = (this.currentPurchase.client.user as any).fullName;
    }
    return name;
  }

  get clientSelectedTags() {
    return this.hasClientSelected ? this.currentPurchase.client.tag : [];
  }

  get clientSelectedPhone() {
    let phone = "";
    if (this.hasClientSelected && this.currentPurchase.client.user.profile) {
      phone = this.currentPurchase.client.user.profile.phone;
    }
    return phone;
  }

  get clientSelectedEmail() {
    let email = "";
    if (this.hasClientSelected && this.currentPurchase.client.user) {
      email = this.currentPurchase.client.user.email;
    }
    return email;
  }

  get clientSelectedDni() {
    let dni = "";
    if (this.hasClientSelected && this.currentPurchase.client.user && this.currentPurchase.client.user.profile) {
      dni = this.currentPurchase.client.user.profile.nif;
    }
    return dni;
  }

  get productAmount() {
    let total = 0;
    if (this.currentPurchase.purchaseLines.length > 0) {
      total = this.currentPurchase.purchaseLines.reduce(
        (total: number, line: any) => {
          return total + line.amount;
        },
        0
      );
    }
    return total;
  }

  private toggleModalCancelPurchase(value: boolean) {
    this.modalCancelPurchaseOpened = value;
  }

  private addClient() {
    this.$store.dispatch("setAddingUser", true);
  }

  private setUserMoneyFlow(amount: number) {
    this.$store.dispatch("setUserMoneyFlow", amount);
  }

  private fetchClientList() {
    const payload = {
      limit: 20,
      search: this.searchString,
      searchPhone: this.searchPhoneString != '+34' ? this.searchPhoneString : '',
      searchNif: this.searchNifString,
    };
    this.$store.dispatch("fetchClientList", payload);
  }

  private async fetchInternalBusinessList() {
    const payload = {
      limit: 20
    };
    this.internalBusinessList = await this.$store.dispatch(
      "fetchInternalBusiness",
      payload
    );
  }

  private fetchConvocation() {
    if (this.convocationId)
      this.$store.dispatch("fetchConvocation", { id: this.convocationId }).then(
        res => {
        },
        err => {
          this.checkResponseError(err);
        }
      );
  }

  private isEmpty(value: number) {
    return value === 0;
  }

  private checkResponseError(err: any) {
    if (err.response.status === 404) {
      this.error = err.response.data.detail;
    } else if (err.response.status === 500) {
      this.error = Constans.internalServerErrorMessage;
    }
  }

  private searchCallback() {
    if (this.searchString === "" && this.searchNifString === "") {
      this.selectedClient = null;
    }
    this.fetchClientList();
  }

  private setCurrentPurchaseLoading(value: boolean) {
    this.$store.dispatch("setCurrentPurchaseLoading", value);
  }

  private async selectClient(option: any, modifyPurchase?: any, index?: any) {
    if (option && option.nif) {
      this.searchNifString = option.nif
    }
    this.selectedClient = option;
    // this.selectedPhoneClient = phone;
    this.updateCurrentPurchaseClient();
    this.setCurrentPurchaseLoading(true);

    await this.fetchUserMoneyFlow();
    if (this.currentPurchaseTypeOfProduct === TypeOfProduct.Course) {
      await this.checkPurchasesInSameConvocation();
      if (this.hasPreviousPurchases && !this.previousPurchaseIsCanceled) {
        await this.updateCurrentPurchaseWithLastPreviousPurchase(modifyPurchase, index);
      } else if (this.hasPreviousPurchases && this.previousPurchaseIsCanceled) {
        await this.convocationMoneyFlow();
      }
      await this.fetchAquiredCourses();
    }
    this.setCurrentPurchaseLoading(false);

  }

  private clearClient() {

    this.selectedClient = null;
    this.selectedPhoneClient = null;
  }

  private clearRecommendationBonusClient() {
    this.recommendationBonusClientSelected = null;
  }

  private fetchUserMoneyFlow() {


    return this.$store.dispatch("fetchUserMoneyFlow", {
      id: this.currentPurchase.client.user.id
    });
  }

  private fetchAquiredCourses() {
    return this.$store.dispatch("fetchAcquiredCoursesList", {
      id: this.currentPurchase.client.user.id
    });
  }

  private goBudget(budget: any) {
    window.open(
      (process.env.NODE_ENV == 'development' ? 'http://' : 'https://') + process.env.VUE_APP_MANAGER_DOMAIN + "/#/client/budget/" + budget.id + "/acceptance/1",
      '_blank' // <- This is what makes it open in a new window.
    );
  }

  private patchPurchase(
    data: any,
    callback: any = () => {
      const a = 1;
    }
  ) {
    const id = data.id;
    delete data.id;
    const payload = {
      id,
      data
    };
    this.$store.dispatch("patchPurchase", payload).then((res: any) => {
      callback();
    });
  }

  private checkPurchasesInSameConvocation(
    callback: any = () => {
      const doNothing = 1;
    }
  ) {
    try {
      const params = {
        id: this.convocationId,
        client: this.client.user.id
      };
      return this.$store.dispatch("fetchPurchaseList", params).then(() => {
        callback();
      });
    } catch (_) {
      console.warn("no se pudo cargar el usuario");
      this.showNotification(
        "No se pudo cargar el usuario",
        SpotlightTextColor.Error,
        15000,
        15000
      );
    }
  }

  private purchaseLineColor(line: PurchaseLine) {
    let color = LineColor.Secondary;
    if (
      (!line.repeater &&
        (line.product &&
          this.sellingCourse &&
          line.product.level &&
          line.product.formativeBranch)) ||
      (line.product &&
        this.sellingCourse &&
        !line.product.formativeBranch &&
        (line.product.acronym && !line.product.acronym.includes("TLP")))
    ) {
      color = LineColor.Primary;
    } else if (
      line.product &&
      this.sellingCourse &&
      line.product.acronym &&
      line.product.acronym.includes("TLP")
    ) {
      color = LineColor.Gold;
    }
    return color;
  }

  private clearPurchase() {
    this.searchString = "";
    this.searchPhoneString = "+34";
    this.searchNifString = "";
    this.$store.dispatch("newCurrentPurchase");
    this.$store.dispatch("setPurchaseListStore", []);
    this.setUserMoneyFlow(0);
  }

  private updateCurrentPurchaseWithLastPreviousPurchase(modifyPurchase?: any, index?: any) {
    let currentPurchase;

    if (modifyPurchase) {
      currentPurchase = this.previousPurchases[index];
      if (currentPurchase.bill && currentPurchase.bill.communicationStatus != 0) {
        currentPurchase.notBillable = true;
      }
      currentPurchase.modifyPurchase = true;
      currentPurchase.previousReserveAmount = currentPurchase.reserveAmount;
      let productNames = currentPurchase.purchaseLines.map(function (purchaseLine: any) {
        return purchaseLine.productName;
      });
      let trace = null;
      if (currentPurchase.trace && currentPurchase.trace != 'False') {
        let currentTrace = JSON.parse(currentPurchase.trace);
        trace = { 'Producto/s': productNames.join(", "), 'Precio': (currentPurchase.totalPrice), 'Reserva anterior': currentTrace[currentTrace.length - 1]['Reserva anterior'], 'A pagar': (currentPurchase.totalPrice - (currentTrace[currentTrace.length - 1]['A pagar'] ? currentTrace[currentTrace.length - 1]['A pagar'] : 0)) }
        currentTrace.push(trace);
        currentPurchase.trace = JSON.stringify(currentTrace);
      } else {
        trace = { 'Producto/s': productNames.join(", "), 'Precio': (currentPurchase.totalPrice), 'Reserva anterior': (currentPurchase.reserveAmount), 'A pagar': (currentPurchase.totalPaymentPending) }
        currentPurchase.trace = JSON.stringify([trace]);
      }
    } else {
      currentPurchase = this.previousPurchases[0];
    }
    for (const line of currentPurchase.purchaseLines) {
      const product = this.getProduct(line.product);
      line.product = product;
      line.color = this.purchaseLineColor(line);
    }
    currentPurchase.totalPrice = 0;
    return this.$store.dispatch("setCurrentPurchase", currentPurchase);


  }

  private updateCurrentPurchaseClient() {
    const client = this.client;
    this.currentPurchase.client = client;
    this.$store.dispatch("setConvocationBalance", 0);
    this.$store.dispatch("updateCurrentPurchase", this.currentPurchase);
  }

  private newPurchase() {
    this.$emit('new-purchase');
    this.$store.dispatch("newCurrentPurchase");
    this.$store.dispatch("setAcquiredCoursesList", []);
    this.searchString = "";
    this.searchPhoneString = "+34";
    this.searchNifString = "";
    const client = Object.assign({}, this.currentPurchase.client);
    // this.$refs.priceSelector.resetRatioButton("useCoursePrice");
  }

  private cancelPurchase() {
    this.modalCancelPurchaseOpened = false;
    this.patchPurchase(
      {
        id: this.currentPurchase.id,
        canceledSuperiorPurchase: true
      },
      () => {
        this.clientNewPurchase();
        this.fetchUserMoneyFlow();
        this.convocationMoneyFlow();
      }
    );
  }

  private convocationMoneyFlow() {
    const clientId = this.currentPurchase.client.user.id;
    return PurchaseService.moneyFlow(clientId, this.convocationId).then(
      (res: any) => {
        const balance = res.data.totalBalance;
        this.$store.dispatch("setConvocationBalance", balance);
      }
    );
  }

  private clientNewPurchase() {
    const priceSelector = this.$refs.priceSelector as SaleInfoViewSpecialOption
    priceSelector.resetRatioButton("useCoursePrice");
    var fiscalData = undefined
    var fiscalDataExtensionId = undefined
    if (this.currentPurchase.fiscalData && this.currentPurchase.fiscalDataExtensionId) {
      fiscalData = this.currentPurchase.fiscalData
      fiscalDataExtensionId = this.currentPurchase.fiscalDataExtensionId
    }
    const client = this.currentPurchase.client;
    this.$store.dispatch("newCurrentPurchase");
    this.currentPurchase.addNewPurchase = true;
    delete this.currentPurchase.voucherOwner;
    this.currentPurchase.client = Object.assign({}, client);
    if (fiscalData && fiscalDataExtensionId) {
      this.currentPurchase.fiscalData = Object.assign([], fiscalData)
      this.currentPurchase.fiscalDataExtensionId = fiscalDataExtensionId
    }
    this.$store.dispatch("updateCurrentPurchase", this.currentPurchase);
  }

  private goToPortal() {
    let id;
    if (this.clientSelectedDni) {
      id = this.clientSelectedDni + '/';
    } else {
      id = '';
    }
    window.open(
      (process.env.NODE_ENV == 'development' ? 'http://' : 'https://') + process.env.VUE_APP_MANAGER_DOMAIN + '/#/client/budget/portal/' + id,
      '_blank' // <- This is what makes it open in a new window.
    );
  }

  // private fetchRefundedOriginBill(billId: any) {
  //   this.$store.dispatch('fetchRefundedOriginBill', { id: billId }).then(
  //     res => {
  //       if (res.originBill) {
  //         this.checkRefundedOriginBillExist(true);
  //       } else if (res.refundedBill) {
  //         this.checkBillhasRefundedBill(true);
  //       }
  //     }
  //   );
  // }

  // private checkRefundedOriginBillExist(newVal: any) {
  //   if (newVal != null) {
  //     this.refundedOriginBillExist = true;
  //   } else {
  //     this.refundedOriginBillExist = false;
  //   }
  // }

  // private checkBillhasRefundedBill(newVal: any) {
  //   if (newVal != null) {
  //     this.BillhasRefundedBill = true;
  //   } else {
  //     this.BillhasRefundedBill = false;
  //   }
  // }

  private fetchBill(billId: any) {
    this.$store.dispatch('fetchBill', { id: billId }).then(
      res => {
        // this.setCurrentBill(res);
        // this.modifyDataPrivateModal = true
        this.currentPurchase.bill = res
        // this.checkFillModalWithBillData()
      }
    );
  }

}
